module.exports = __webpack_public_path__ + "assets/a2c5f22edfd3930ad012947518e563a6.mp3";